// Configuración de la pantalla "Ingreso manual Inter Cía".

// Roles de los abogados que pueden recibir el caso: los mismos que lista "Actualiza / Reasigna Recupero".
export const ROLES_RESPONSABLE = ['0070COBRAEX', '0070ABOEXT', '70PRSIPACIA'];
export const TIPO_PERSONA_PROVEEDOR = '0080PROVE00';

// concepto_detalle de donde salen los combos.
export const CONCEPTO_TIPO_SINIESTRO = 15;
export const CONCEPTO_TIPO_VEHICULO = 16;
export const CONCEPTO_CAUSAL = 300; // causal del siniestro (opcional); el servidor la guarda en adc_int_causaEXT
export const CONCEPTO_COLOR = 23;   // color del vehículo (opcional)
export const CONCEPTO_USO = 20;     // uso del vehículo (opcional)

// Modos de ingreso (RG-591): los define el servidor según los roles del usuario.
export const MODO_RECUPERO = 'RECUPERO'; // Recupero Directo
export const MODO_DEFENSA = 'DEFENSA';   // Defensa entre compañías (cartas / pagos inter cía): aún no disponible

// El combo se acota a Pérdida Total y Pérdida Parcial: la derivación a Inter Cía cambia cualquier otro tipo a Pérdida Parcial.
export const TIPOS_SINIESTRO_PERMITIDOS = ['15001', '15005'];

// tablas_generales de donde salen comunas y ciudades (endpoint "generales").
export const PARAMETRO_COMUNAS = 45;
export const PARAMETRO_CIUDADES = 47;
